import { render, staticRenderFns } from "./PlantVarietyHistoryList.vue?vue&type=template&id=1adb75f3&"
import script from "./PlantVarietyHistoryList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyHistoryList.vue?vue&type=style&index=0&id=1adb75f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports